import { Navigate } from "react-router-dom";

export const PrivateRoute = ({ children }) => {
  let aimsAdminToken = localStorage.getItem("aimsAdminToken"); 
  if (!aimsAdminToken) {
    return <Navigate to="/log-in" />;
  }

  return <>{children}</>;
};
